import React, { useState } from 'react';
import { showToast } from './Toast';

function Menu() {
  const [showAll, setShowAll] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Modal customization states
  const [selectedItem, setSelectedItem] = useState(null);
  const [modalFruits, setModalFruits] = useState([]);
  const [modalCrunch, setModalCrunch] = useState([]);
  const [modalSauce, setModalSauce] = useState('honey');
  const [modalQuantity, setModalQuantity] = useState(1);
  const [modalNotes, setModalNotes] = useState('');

  // Popular Picks (9 items total, displayed 3 per view)
  const popularPicks = [
    {
      id: 'strawberry-croissant',
      name: 'Strawberry Croissant',
      thName: 'ครัวซองต์สตรอว์เบอร์รี่สด & วิปครีม',
      price: 120,
      image: '/img/image1.webp',
      badge: 'Bestseller',
      desc: 'ครัวซองต์เนยสดฝรั่งเศส กรอบนอกนุ่มใน ท็อปด้วยสตรอว์เบอร์รี่สดลูกโตและวิปครีมนุ่มละมุน'
    },
    {
      id: 'blueberry-bowl',
      name: 'Blueberry Yogurt Bowl',
      thName: 'กรีกโยเกิร์ตบลูเบอร์รี่โบว์ล & กราโนล่า',
      price: 139,
      image: '/img/image.webp',
      badge: 'Signature',
      desc: 'กรีกโยเกิร์ตแท้เนื้อแน่นเข้มข้น เสิร์ฟพร้อมบลูเบอร์รี่สด กราโนล่าโฮมเมด และน้ำผึ้งป่า'
    },
    {
      id: 'fig-honey-croissant',
      name: 'Fig & Honey Croissant',
      thName: 'ครัวซองต์ฟิกมะเดื่อฝรั่ง & น้ำผึ้งป่า',
      price: 125,
      image: '/img/image3.webp',
      badge: 'Chef Special',
      desc: 'เมนูพิเศษประจำฤดูกาล ฟิกสดหวานฉ่ำท็อปบนครัวซองต์ราดน้ำผึ้งป่าออร์แกนิก'
    },
    {
      id: 'banana-bowl',
      name: 'Banana Yogurt Bowl',
      thName: 'กรีกโยเกิร์ตกล้วยหอม & คาราเมลนัท',
      price: 135,
      image: '/img/image4.webp',
      badge: 'Popular',
      desc: 'กรีกโยเกิร์ตผสมกล้วยหอมทองสไลซ์ ท็อปด้วยถั่วอัลมอนด์อบกรอบและซอสคาราเมลหอมหวาน'
    },
    {
      id: 'mango-sunshine',
      name: 'Mango Sunshine Scoop',
      thName: 'กรีกโยเกิร์ตมะม่วงมหาชนก & มะพร้าวอบ',
      price: 129,
      image: '/img/image6.webp',
      badge: 'Summer Fresh',
      desc: 'ความสดชื่นระดับพรีเมียม มะม่วงสุกฉ่ำรสหวานอมเปรี้ยว ท็อปด้วยเกล็ดมะพร้าวอบหอม'
    },
    {
      id: 'matcha-berry',
      name: 'Matcha Berry Delight',
      thName: 'ครัวซองต์มัทฉะเกรดพรีเมียม & เบอร์รี่',
      price: 145,
      image: '/img/image14.webp',
      badge: 'Premium',
      desc: 'ผงมัทฉะเกรดพิธีการชิซูโอกะ เข้มข้นกลมกล่อม ผสานความสดชื่นจากมิกซ์เบอร์รี่สด'
    },
    {
      id: 'kiwi-granola',
      name: 'Kiwi & Granola Bowl',
      thName: 'โบว์ลกีวี่ทอง & โอ๊ต Crunch',
      price: 130,
      image: '/img/image5.webp',
      badge: 'Healthy Pick',
      desc: 'วิตามินซีสูงจากกีวี่ทองนิวซีแลนด์ จับคู่กรีกโยเกิร์ตเนื้อนุ่มและโอ๊ตเฟล็กซ์กรุบกรอบ'
    },
    {
      id: 'dark-choco-croissant',
      name: 'Dark Choco Nut Croissant',
      thName: 'ครัวซองต์ดาร์กช็อกโกแลต & อัลมอนด์',
      price: 135,
      image: '/img/image13.webp',
      badge: 'Choco Lover',
      desc: 'ดาร์กช็อกโกแลตแท้ 70% สอดไส้และราดท็อป โรยด้วยอัลมอนด์สไลซ์อบกรอบหอมมัน'
    },
    {
      id: 'peach-honey-bowl',
      name: 'Peach & Honey Delight',
      thName: 'กรีกโยเกิร์ตพีชเชื่อม & น้ำผึ้ง',
      price: 140,
      image: '/img/image12.webp',
      badge: 'New Arrival',
      desc: 'ลูกพีชฉ่ำน้ำหอมหวาน ราดซอสพีชโฮมเมดและน้ำผึ้ง ทานคู่กับกรีกโยเกิร์ตสดทุกวัน'
    }
  ];

  const fruitOptions = [
    { id: 'strawberry', name: 'สตรอว์เบอร์รี่สด 🍓', price: 15 },
    { id: 'blueberry', name: 'บลูเบอร์รี่สด 🫐', price: 15 },
    { id: 'mango', name: 'มะม่วงสุกฉ่ำ 🥭', price: 15 },
    { id: 'kiwi', name: 'กีวี่สด 🥝', price: 15 },
    { id: 'apple', name: 'แอปเปิ้ลฟูจิ 🍎', price: 15 },
    { id: 'grape', name: 'องุ่นไร้เมล็ด 🍇', price: 15 }
  ];

  const crunchOptions = [
    { id: 'granola', name: 'กราโนล่าโฮมเมด 🥣', price: 10 },
    { id: 'oat', name: 'โอ๊ตเฟล็กซ์ 🌾', price: 10 },
    { id: 'almond', name: 'อัลมอนด์สไลซ์ 🥜', price: 10 },
    { id: 'coconut', name: 'เกล็ดมะพร้าวอบ 🥥', price: 10 }
  ];

  const menuItems = [
    { image: '/img/image.webp', title: 'Blueberry Bowl' },
    { image: '/img/image1.webp', title: 'Strawberry Croissant' },
    { image: '/img/image2.webp', title: 'Berry Bliss' },
    { image: '/img/image3.webp', title: 'Fig & Honey' },
    { image: '/img/image4.webp', title: 'Banana Nut' },
    { image: '/img/image5.webp', title: 'Kiwi Sparkle' },
    { image: '/img/image6.webp', title: 'Mango Sunshine' },
    { image: '/img/image7.webp', title: 'Grape Medley' },
    { image: '/img/image8.webp', title: 'Granola Crunch' },
    { image: '/img/image9.webp', title: 'Pure Greek Scoop' },
    { image: '/img/image10.webp', title: 'Fresh Berry Mix' },
    { image: '/img/image11.webp', title: 'Almond Honey' },
    { image: '/img/image12.webp', title: 'Peach Delight' },
    { image: '/img/image13.webp', title: 'Dark Choco Bowl' },
    { image: '/img/image14.webp', title: 'Matcha Greek' },
    { image: '/img/image15.webp', title: 'Summer Tropical' }
  ];

  const itemsPerPage = 3;
  const maxIndex = Math.max(0, popularPicks.length - itemsPerPage);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1 > maxIndex ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 < 0 ? maxIndex : prev - 1));
  };

  const openCustomizeModal = (item) => {
    setSelectedItem(item);
    setModalFruits([]);
    setModalCrunch([]);
    setModalSauce('honey');
    setModalQuantity(1);
    setModalNotes('');
  };

  const toggleModalFruit = (fruitId) => {
    setModalFruits(prev =>
      prev.includes(fruitId) ? prev.filter(f => f !== fruitId) : [...prev, fruitId]
    );
  };

  const toggleModalCrunch = (crunchId) => {
    setModalCrunch(prev =>
      prev.includes(crunchId) ? prev.filter(c => c !== crunchId) : [...prev, crunchId]
    );
  };

  const calculateModalTotal = () => {
    if (!selectedItem) return 0;
    let base = selectedItem.price;
    base += modalFruits.length * 15;
    base += modalCrunch.length * 10;
    return base * modalQuantity;
  };

  const handleConfirmAddToCart = () => {
    if (!selectedItem) return;
    const total = calculateModalTotal();

    showToast(`เพิ่ม "${selectedItem.name}" (฿${total}) พร้อมท็อปปิ้งที่เลือกเรียบร้อย!`);

    // Dispatch quick menu selection to Builder
    window.dispatchEvent(new CustomEvent('selectQuickMenu', {
      detail: { menuCode: selectedItem.name, price: total }
    }));

    setSelectedItem(null);
  };

  const visiblePicks = popularPicks.slice(currentIndex, currentIndex + itemsPerPage);

  return (
    <section id="popular" className="py-20 bg-white relative overflow-hidden">
      {/* Subtle Aegean background grid */}
      <div className="absolute inset-0 opacity-25 bg-[linear-gradient(to_right,#d0deef_1px,transparent_1px),linear-gradient(to_bottom,#d0deef_1px,transparent_1px)] bg-[size:32px_32px]"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">

        {/* Popular Picks Header: Title + Arrow Navigation Bar */}
        <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-8 pb-4 border-b border-brand-200/70 gap-4">
          <div className="flex items-center gap-3">
            <h2 className="font-serif text-3xl sm:text-4xl text-brand-800 font-semibold tracking-tight">
              Popular Picks
            </h2>
            <img
              src="/logo_small.png"
              alt="Olive sprig"
              className="w-7 h-7 object-contain transform -rotate-12"
            />
          </div>

          {/* Left/Right Arrow Navigation Slider Bar */}
          <div className="flex items-center justify-between sm:justify-end gap-3">
            <button
              onClick={() => setShowAll(!showAll)}
              className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.18em] font-semibold text-brand-600 hover:text-brand-800 transition-colors mr-2"
            >
              {showAll ? 'Show Highlights' : 'View Full Menu'}
              <i className={`fas fa-arrow-right text-[11px] transform ${showAll ? 'rotate-90' : ''} transition-transform`}></i>
            </button>

            <div className="flex items-center space-x-2 bg-brand-50/80 p-1.5 rounded-full border border-brand-200">
              <button
                onClick={prevSlide}
                className="w-9 h-9 rounded-full bg-white text-brand-800 hover:bg-brand-600 hover:text-white flex items-center justify-center transition-all shadow-2xs active:scale-95 cursor-pointer border border-brand-200/70"
                title="ย้ายไปรายการซ้าย"
                aria-label="Previous menu items"
              >
                <i className="fas fa-chevron-left text-xs"></i>
              </button>

              <span className="text-xs font-mono font-semibold text-brand-700 px-2 min-w-[45px] text-center">
                {currentIndex + 1}-{Math.min(currentIndex + itemsPerPage, popularPicks.length)}
              </span>

              <button
                onClick={nextSlide}
                className="w-9 h-9 rounded-full bg-white text-brand-800 hover:bg-brand-600 hover:text-white flex items-center justify-center transition-all shadow-2xs active:scale-95 cursor-pointer border border-brand-200/70"
                title="ย้ายไปรายการขวา"
                aria-label="Next menu items"
              >
                <i className="fas fa-chevron-right text-xs"></i>
              </button>
            </div>
          </div>
        </div>

        {/* 3 Columns Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 transition-all duration-500">
          {visiblePicks.map((item) => (
            <div
              key={item.id}
              onClick={() => openCustomizeModal(item)}
              className="group bg-white rounded-3xl border border-brand-200/80 shadow-xs hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1.5 overflow-hidden flex flex-col cursor-pointer relative"
            >
              {/* Image Frame */}
              <div className="aspect-[4/3] w-full overflow-hidden bg-brand-50 relative">
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 bg-white/90 backdrop-blur-xs text-brand-800 text-[10px] uppercase font-bold tracking-wider px-3 py-1 rounded-full shadow-2xs border border-brand-100">
                  {item.badge}
                </span>
              </div>

              {/* Card Meta */}
              <div className="p-5 flex-1 flex flex-col justify-between border-t border-brand-100/70">
                <div>
                  <h3 className="font-serif text-xl font-medium text-brand-900 leading-snug group-hover:text-brand-600 transition-colors">
                    {item.name}
                  </h3>
                  <p className="text-xs text-brand-600/80 font-light mt-1 line-clamp-2">
                    {item.thName}
                  </p>
                </div>

                <div className="mt-5 pt-3.5 border-t border-brand-100/60 flex items-center justify-between">
                  <div>
                    <span className="text-xs text-brand-400 block font-light">เริ่มต้น</span>
                    <span className="text-lg font-bold text-brand-700">
                      ฿{item.price}
                    </span>
                  </div>

                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      openCustomizeModal(item);
                    }}
                    className="px-4 py-2 rounded-xl bg-brand-50 hover:bg-brand-600 text-brand-700 hover:text-white font-medium transition-all text-xs flex items-center space-x-1.5 shadow-2xs group-hover:bg-brand-600 group-hover:text-white"
                  >
                    <span>เลือกส่วนผสมเพิ่ม</span>
                    <i className="fas fa-plus text-[10px]"></i>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Indicator dots for sliding pages */}
        <div className="flex justify-center items-center space-x-2 mt-8">
          {Array.from({ length: maxIndex + 1 }).map((_, idx) => (
            <button
              key={idx}
              onClick={() => setCurrentIndex(idx)}
              className={`h-2.5 rounded-full transition-all cursor-pointer ${currentIndex === idx ? 'w-8 bg-brand-600' : 'w-2.5 bg-brand-200 hover:bg-brand-400'
                }`}
              aria-label={`Go to slide ${idx + 1}`}
            />
          ))}
        </div>

        {/* Expandable Full Menu Showcase */}
        {showAll && (
          <div className="mt-14 pt-10 border-t border-brand-200/70">
            <div className="text-center mb-8">
              <span className="text-xs uppercase tracking-[0.2em] text-brand-500 font-bold block mb-1">
                Artisanal Collection
              </span>
              <h3 className="font-serif text-2xl text-brand-900">
                Fresh From Our Kitchen Every Day
              </h3>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
              {menuItems.map((item, idx) => (
                <div
                  key={idx}
                  className="bg-white rounded-xl border border-brand-200/70 p-2 shadow-2xs hover:shadow-md transition-all group text-center"
                >
                  <div className="aspect-square rounded-lg overflow-hidden bg-brand-50 mb-2">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform"
                    />
                  </div>
                  <span className="text-xs font-medium text-brand-800 truncate block">
                    {item.title}
                  </span>
                </div>
              ))}
            </div>
          </div>
        )}

      </div>

    </section>
  );
}

export default Menu;
